export const FETCH_CLASSES_STUDENTS = "FETCH_CLASSES_STUDENTS";
export const FETCH_CLASSES_STUDENTS_SUCCESS = "FETCH_CLASSES_STUDENTS_SUCCESS";
export const FETCH_CLASSES_STUDENTS_ERROR = "FETCH_CLASSES_STUDENTS_ERROR";

export const REVIEW_REPORT = "REVIEW_REPORT";
export const REVIEW_REPORT_SUCCESS =
  "REVIEW_REPORT_SUCCESS";
export const REVIEW_REPORT_ERROR = "REVIEW_REPORT_ERROR";

export const SET_SELECTED_CLASS = "SET_SELECTED_CLASS";
export const SET_SELECTED_STUDENT = "SET_SELECTED_STUDENT";
export const SET_REPORT_DATA = "SET_REPORT_DATA";



export const GENERATE_REPORT = "GENERATE_REPORT";
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS";
export const GENERATE_REPORT_ERROR = "GENERATE_REPORT_ERROR";